<template>
  <div>
    <select
      class="form-control select2"
      style="width: 100%;"
      v-model="defaultSelected"
    >
      <option
        v-for="(item, index) in options"
        :selected="itemChoose == item.id ? 'selected' : ''"
        :data="item"
        :key="index"
        :value="item.id"
        :disabled="disable_period ? !item.current_period : false"
      >
        {{ item.text }}
      </option>
    </select>
  </div>
</template>

<script>
import "select2";
import "select2/dist/css/select2.min.css";
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css";

export default {
  name: "Select2",
  props: {
    options: {
      type: Array,
      default() {
        return [
          {
            text: "",
            id: 1
          }
        ];
      }
    },
    isMultiple: {
      type: Boolean,
      default() {
        return false;
      }
    },
    defaultSelected: {
      type: Number,
      default() {
        return null;
      }
    },
    itemChoose: {
      type: Number,
      default() {
        return 0;
      }
    },
    placeHolder: {
      type: String,
      default() {
        return "";
      }
    },
    isAllowClear: {
      type: Boolean,
      default() {
        return false;
      }
    },
    disable_period: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      selected: ""
    };
  },
  methods: {
    formatState: function(option) {
      this.selected = option;
      this.$emit("change", this.selected);
      return option.text;
    }
  },
  mounted() {
    $(this.$el)
      .find(".select2")
      .select2({
        placeholder: this.placeHolder,
        allowClear: this.isAllowClear,
        theme: "bootstrap",
        templateSelection: this.formatState,
        multiple: this.isMultiple
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.select2-container .select2-selection--single .select2-selection__rendered {
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/LTESelect2Input.vue